import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import MobileCTA from "@/components/site/MobileCTA";
import ScrollScanner from "@/components/ScrollScanner";
import Reveal from "@/components/site/Reveal";
import RelatedLinks from "@/components/site/RelatedLinks";
import { useSeo } from "@/lib/useSeo";

export default function About() {
  useSeo({
    title: "About Meridian | Specialist Bed Bug Treatment Vancouver",
    description: "Meridian is a specialist bed bug treatment service for Vancouver and the Lower Mainland — focused on one problem, handled with preparation, discretion and proper follow-up.",
    path: "/about",
  });
  return (
    <div className="overflow-x-hidden pb-16 lg:pb-0">
      <ScrollScanner />
      <Navbar />
      <main id="main-content">
        <section className="bg-background px-5 pt-32 pb-24 lg:px-8 lg:pt-40 lg:pb-32">
          <div className="mx-auto max-w-3xl">
            <Reveal>
              <div className="flex items-center gap-3">
                <span className="h-px w-8 bg-accent" />
                <span className="text-[11px] font-semibold uppercase tracking-[0.22em] text-accent">About</span>
              </div>
              <h1 className="mt-5 font-heading text-4xl font-extrabold leading-[1.05] tracking-tight text-primary sm:text-5xl lg:text-[3.4rem]">About Meridian.</h1>
              <p className="mt-6 text-lg leading-relaxed text-muted-foreground">Different Bug. Different Battle.</p>
              <div className="mt-10 space-y-6 text-base leading-relaxed text-muted-foreground">
                <p>
                  Meridian Bed Bug Treatment is a specialized bed bug treatment service operating across Vancouver and the Lower Mainland. We are not a general pest control company that handles a long list of other pests — we focus on one problem and treat it with the preparation, discipline and follow-through it demands. Bed bugs are a distinct challenge: they hide deep in seams and crevices, travel between units, and survive long gaps between feedings. A generic approach is rarely enough, which is why our entire process is built around the bed bug lifecycle and where it lives.
                </p>
                <p>
                  Our service is designed for the people who deal with this problem most — homeowners, condo and apartment residents, property managers, hotels and short-term rental hosts in Vancouver, Burnaby, Richmond, Surrey, Coquitlam, North Vancouver and surrounding communities. We work through a clear, repeatable path: Book, Prepare, Treat, Aftercare, and Follow-up — so every client knows exactly what happens next. Discretion is built into the way we operate, with unmarked service and respectful communication, because a bed bug issue is already stressful without unwanted attention from neighbours or guests.
                </p>
                <p>
                  Meridian was built on a simple belief: bed bug treatment is its own discipline, not an add-on. Our technicians prepare the space properly, apply treatment to the places bed bugs actually hide, and return for follow-up where the treatment program calls for it. We help people in British Columbia get back to sleeping normally — privately, professionally and without the chaos of a rushed or improvised visit.
                </p>
              </div>
            </Reveal>
          </div>
        </section>
        <RelatedLinks links={[
          { to: "/bed-bug-treatment-vancouver", label: "Guide", title: "Bed Bug Treatment in Vancouver", desc: "Signs, preparation and what to expect from a specialist treatment.", cta: "Read the guide" },
          { to: "/contact", label: "Book", title: "Book a treatment", desc: "Share a few property details and we'll confirm availability.", cta: "Contact Meridian" },
        ]} />
      </main>
      <Footer />
      <MobileCTA />
    </div>
  );
}